module.exports = __webpack_public_path__ + "img/menu.8ccbc58d.svg";